<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>動能-Service</h2>
            <h2 style="padding-top: 10px;">服務內容 企業數位轉型四大方向</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<!-- <div class="partner-area">
    <div class="container">
        <h2>原廠品牌Logo</h2>
        <div class="partner-slides owl-carousel owl-theme">
            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/1.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/2.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/3.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/4.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/5.png" alt="image"></a>
            </div>

            <div class="single-partner-item">
                <a href="#"><img src="assets/img/partner/6.png" alt="image"></a>
            </div>
        </div>
    </div>
</div> -->
<!-- Start Services Area -->
<section class="services-area ptb-100">
    <div class="services-container container">
        <div class="row">
            <div class="row " style="margin-left: 0px; margin-right: 0px; ">
                <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5 ">
                    <a href="/service-details?info=SAP 企業流程改造"><img src="assets/img/services/icon_pic_8.png"></a>
                </div>
                <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5 ">
                    <a href="/service-details?info=軟體定義資訊中心"><img src="assets/img/services/icon_pic_9.png"></a>
                </div>
                <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5 ">
                    <a href="/service-details?info=企業混合雲"><img src="assets/img/services/icon_pic_10.png"></a>
                </div>
                <div class="col-6 col-lg-3 col-md-6 col-sm-6 mb-5 ">
                    <a href="/service-details?info=資訊專案服務"><img src="assets/img/services/icon_pic_19.png"></a>
                </div>
            </div>
            <!-- <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/plug.png" alt="image">
                    </div>
                    <h3><a href="/service-details?info=SAP 企業流程改造">SAP 企業流程改造</a></h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/drone.png" alt="image">
                    </div>
                    <h3><a href="/service-details?info=軟體定義資訊中心">軟體定義資訊中心</a></h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/sensor.png" alt="image">
                    </div>
                    <h3><a href="/service-details?info=企業混合雲">企業混合雲</a></h3>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/sensor.png" alt="image">
                    </div>
                    <h3><a href="/service-details?info=資訊專案服務">資訊專案服務</a></h3>
                </div>
            </div> -->

            <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/database.png" alt="image">
                    </div>
                    <h3><a href="#">AI For Cloud Services</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/augmented-reality.png" alt="image">
                    </div>
                    <h3><a href="#">Virtual Reality</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-services-box">
                    <div class="icon">
                        <img src="assets/img/services/deep.png" alt="image">
                    </div>
                    <h3><a href="#">Deep Learning</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore.</p>
                </div>
            </div> -->

            <!-- <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <a href="#" class="prev page-numbers"><i class="fas fa-angle-double-left"></i></a>
                    <a href="#" class="page-numbers">1</a>
                    <span class="page-numbers current" aria-current="page">2</span>
                    <a href="#" class="page-numbers">3</a>
                    <a href="#" class="page-numbers">4</a>
                    <a href="#" class="next page-numbers"><i class="fas fa-angle-double-right"></i></a>
                </div>
            </div> -->
        </div>
    </div>
    <div class="container" style="max-width: 100%;text-align: center;padding-right: 0px; padding-left: 0px;">
        <div>
            <img src="assets/img/services/pic_19.png" class="pic19">
        </div>
    </div>

    <!-- <div class="services-shape"><img src="assets/img/services-shape.png" alt="image"></div> -->
</section>
<!-- End Services Area -->